import { Link } from "react-router-dom";
import { Lock, Megaphone } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth";

export default function RequireMarketing({ children, feature = "Marketing Suite" }) {
  const { user } = useAuth();

  if (user?.marketing_enabled === true) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#FAF6EE] flex items-center justify-center p-8">
      <div className="max-w-lg w-full text-center">
        <div
          className="w-16 h-16 rounded-2xl mx-auto mb-6 grid place-items-center"
          style={{ background: "#F2EADB", border: "1px solid #E8DFD1" }}
        >
          <Lock className="w-7 h-7 text-[#C96F53]" strokeWidth={1.75} />
        </div>
        <div className="text-caption uppercase tracking-[0.22em] text-[#A69C92] mb-3">
          Access controlled
        </div>
        <h2 className="font-editorial text-h2 sm:text-h1 leading-tight text-[#2B2320] mb-3">
          {feature} is not enabled
        </h2>
        <p className="text-[#6B6158] text-sm leading-relaxed mb-8">
          Marketing access is enabled per user by a Polaris superadmin.
        </p>
        <Link to="/app">
          <Button
            variant="ghost"
            className="rounded-full text-[#6B6158] hover:text-[#2B2320] hover:bg-[#F2EADB] h-11 px-6 text-sm"
          >
            <Megaphone className="w-3.5 h-3.5 mr-1.5" />
            Back to dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
